import React from 'react'
import UpdateGateForm from '../../../component/form/master/gate/UpdateGateForm'

export default function UpdateGate() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <UpdateGateForm />
                    </div>
                </div>
            </div>
        </>
    )
}


